import { LoginModal } from "../pages/auth/LoginModal";
import { RegisterModal } from "../pages/register/RegisterModal";
import { useConditional } from "../core/hooks/useConditional";
import { logoff, useSession } from "../core/hooks/useSession";
import { go } from "../core/route/Route";
import { settings } from "../settings";
import { useChannel } from "../core/hooks/useChannel";
import { useCallback, useState } from "react";
import { Icon } from "../core/ui/icons";


export const PageTitleChannel = "page-title";

export const PageTitleMessages = {
	SET_TITLE: "set-title",

	RESET: "reset",
}

export function PageTitle(props: {

}) {

	const [title, setTitle] = useState("");

	useChannel(PageTitleChannel, useCallback((msg) => {
		if (msg.type === PageTitleMessages.SET_TITLE) {
			setTitle(msg.title);
		} else if (msg.type === PageTitleMessages.RESET) {
			setTitle("");
		}
	}, []));

	return (
			<div
				className="page-title"
			>
				<span className="font-large"><a href="/" style={{color:"#fff", textDecoration:"none"}}>{title}</a></span>
			</div>
	);
}